// eslint-disable-next-line no-restricted-imports
import { background } from '@twisto/theme/param-dark-palette'

/**
 * Function set background on html element for loading state when user
 * use dark mode.
 * @param HTMLBackround background of html for darkmode
 */

export const changeHTMLBackground = (
  HTMLBackround: string = background.main
): string =>
  // prettier-ignore
  [
    'const themeMediaQuery =',
        'window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");',
    '(function () {',
        'let themeStorage;',
        'try{themeStorage = JSON.parse(window.localStorage.getItem("themeMode"))}catch(e){};',
        'if (themeStorage === "light" ) return;',
        'if (themeMediaQuery.matches || themeStorage === "dark") {',
            'window.document.querySelector("html").style.backgroundColor =',
            `"${HTMLBackround}";`,
        '}',
    '})();',
    ].join('')
